import React, { useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

const rootCategorySchema = z.object({
  name: z.string().min(1, "Tên danh mục là bắt buộc"),
  description: z.string().optional(),
  categoryId: z.union([
    z.string().min(1, "Danh mục là bắt buộc"),
    z.number().min(1, "Danh mục là bắt buộc"),
  ]),
});

const EditCategoryModal = ({
  show,
  handleClose,
  rootCategory,
  handleUpdate,
  parents,
  categoryId,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm({
    defaultValues: rootCategory,
    resolver: zodResolver(rootCategorySchema),
  });

  useEffect(() => {
    if (categoryId) {
      setValue("categoryId", categoryId);
    }
  }, [categoryId, setValue]);

  useEffect(() => {
    if (rootCategory) {
      reset(rootCategory);
    }
  }, [rootCategory, reset]);

  const onSubmit = (data) => {
    handleUpdate({ ...rootCategory, ...data });
    handleClose();
    reset();
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>Chỉnh sửa danh mục gốc</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group controlId="rootCategoryName">
            <Form.Label>Tên danh mục</Form.Label>
            <Form.Control
              type="text"
              {...register("name")}
              isInvalid={!!errors.name}
            />
            <Form.Control.Feedback type="invalid">
              {errors.name?.message}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group controlId="rootCategoryDescription">
            <Form.Label>Mô tả</Form.Label>
            <Form.Control
              type="text"
              {...register("description")}
              isInvalid={!!errors.description}
            />
            <Form.Control.Feedback type="invalid">
              {errors.description?.message}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="categoryId">
            <Form.Label>Danh mục cha</Form.Label>
            <Form.Control
              as="select"
              {...register("categoryId")}
              isInvalid={!!errors.categoryId}
            >
              <option value="">Chọn danh mục</option>
              {(parents || []).map((item, index) => (
                <option key={index} value={item.id}>
                  {item.name}
                </option>
              ))}
            </Form.Control>
            {errors.categoryId && (
              <Form.Control.Feedback type="invalid">
                {errors.categoryId.message}
              </Form.Control.Feedback>
            )}
          </Form.Group>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Đóng
            </Button>
            <Button variant="primary" type="submit">
              Cập nhật
            </Button>
          </Modal.Footer>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default EditCategoryModal;
